module.exports = __webpack_public_path__ + "static/media/omit_page.630235ff.svg";